import AuthenticationActions, {
  AuthenticationSelectors,
} from "Redux/AuthenticationRedux";
import React, { Component } from "react";
import styles, {
  AddButton,
  AuthButton,
  AuthButtonContainer,
  HomeContainer,
  HomeTitle,
  ProfileIcon,
} from "./styles";

import { GiHamburgerMenu } from "react-icons/gi";
import LoginModal from "Modals/LoginModal";
import MobileNavigation from "Components/MobileNavigation";
import NavbarDropdown from "Components/NavbarDropdown";
import { ProfileSelectors } from "Redux/ProfileRedux";
import { compose } from "redux";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import { Navbar } from "react-bootstrap";
import { Colors } from "Themes";

const DropdownButton = (props) => {
  return (
    <div onClick={props.onClick} className={props.classes.navItemContainer}>
      {props.title}
    </div>
  );
};

class NavbarScreen extends Component {
  state = {
    showLoginModal: false,
    showNavigationModal: false,
    openSidebarNavigation: false, // Determines whether our sidebar is open or closed
    modalTitle: "Login",
  };

  handleSearch = (val) => {
    const { search, history } = this.props;
    val.preventDefault();
    const searchTerm = val.target.searchTerm.value;
    search({ searchTerm, history });
    this.setState({
      searchBarClear: true,
    });
  };

  _modalClose = () => {
    this.setState({
      openFixModal: false,
    });
  };

  _addProject = (navRoute, title) => {
    const { history, isAuthenticated } = this.props;
    if (isAuthenticated) {
      history.push(navRoute);
    } else {
      this.setState({
        showLoginModal: true,
        modalTitle: title,
      });
    }
  };

  toggleMobileNavigation = () => {
    this.setState((prevState) => ({
      openSidebarNavigation: !prevState.openSidebarNavigation,
    }));
  };

  _logout = async () => {
    const { logout, history } = this.props;
    await logout();
    history.push(navRoutes.root);
  };

  render() {
    const SettingsButton = withRouter(({ history }) => (
      <div
        onClick={() => {
          history.push("/Settings/General");
        }}
      >
        Settings
      </div>
    ));

    const LogoutButton = withRouter(({ history }) => (
      <div
        onClick={this._logout}
        className={this.props.classes.navItemContainer}
      >
        Logout
      </div>
    ));

    const ProtectedRoutes = withRouter(({ history }) => {
      const { user, profile } = this.props;
      return (
        <NavbarDropdown userDetails={user} profile={profile}>
          <DropdownButton
            title={"View Updates"}
            onClick={() => history.push(navRoutes.updateFeed)}
            classes={classes}
          />
          <DropdownButton
            title={"Explore Projects"}
            onClick={() => history.push(navRoutes.explore)}
            classes={classes}
          />
          <DropdownButton
            title={"My Profile"}
            onClick={() => history.push(`${navRoutes.profile}/${user.id}`)}
            classes={classes}
          />
          <DropdownButton
            title={"Edit Projects"}
            onClick={() => history.push(`${navRoutes.myProjects}`)}
            classes={classes}
          />
          <SettingsButton />
          <LogoutButton />
        </NavbarDropdown>
      );
    });

    const { isAuthenticated, classes, history } = this.props;
    const { showLoginModal, openSidebarNavigation, modalTitle } = this.state;

    return (
      <>
        <MobileNavigation
          open={openSidebarNavigation}
          user={this.props.user}
          onHide={this.toggleMobileNavigation}
          history={history}
          logout={this._logout}
        />
        <Navbar
          variant="dark"
          className={classes.navbar}
          style={{
            backgroundColor: Colors.mainColor,
          }}
        >
          <LoginModal
            show={showLoginModal}
            onHide={() => this.setState({ showLoginModal: false })}
            history={history}
            title={modalTitle}
          />
          <HomeContainer onClick={() => history.push(navRoutes.updateFeed)}>
            <HomeTitle>Tinker Update</HomeTitle>
          </HomeContainer>
          <div className={classes.dropdown}>
            <AddButton>
              <AuthButton
                onClick={() =>
                  this._addProject(
                    navRoutes.createProject,
                    "Login to create a project"
                  )
                }
              >
                Start a project
              </AuthButton>
              <AuthButton
                onClick={() =>
                  this._addProject(
                    navRoutes.postUpdate,
                    "Login to post an update"
                  )
                }
              >
                Post an update
              </AuthButton>
            </AddButton>
            {isAuthenticated ? (
              <>
                <ProtectedRoutes />
                <ProfileIcon
                  onClick={() => this.setState({ showNavigationModal: true })}
                >
                  <GiHamburgerMenu
                    fontSize={40}
                    onClick={this.toggleMobileNavigation}
                  />
                </ProfileIcon>
              </>
            ) : (
              <AuthButtonContainer>
                <AuthButton
                  onClick={() => history.push(navRoutes.login)}
                  variant="info"
                >
                  Login
                </AuthButton>
                <AuthButton
                  onClick={() => history.push(navRoutes.signup)}
                  variant="info"
                >
                  Signup
                </AuthButton>
              </AuthButtonContainer>
            )}
          </div>
        </Navbar>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
    user: AuthenticationSelectors.getUserDetails(state),
    profile: ProfileSelectors.getProfile(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(AuthenticationActions.logout()),
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withStyles(styles),
  withRedux
)(NavbarScreen);
